module.exports = __webpack_public_path__ + "img/noimage.58f03ebd.png";